<template>
  <div class="wrapper">
    <div class="container">
      <div class="icon-area">
        <div class="icon-container">
          <gl-icon :icon="icon" />
        </div>
      </div>
      <div class="content">
        <div class="title">{{ title }}</div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    summary: String,
    warn: Boolean,
    errors: Array,
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  transition: background-color 0.2s ease-in-out;

  .container {
    display: flex;
    flex: 1;
    // padding-bottom: var(--spacing-small);
    padding-right: var(--spacing-medium);
    padding-top: var(--spacing-small);
  }
}

.icon-area {
  .icon-container {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    margin-left: var(--spacing-medium);
    margin-right: var(--spacing-medium);
    padding: var(--spacing-small);
    position: relative;
  }
  .gl-icon {
    // color: #fff;
  }
}

.content {
  flex: 1;
}

.title {
  line-height: 35px;
  font-size: var(--font-size-normal);
}

.summary {
  color: var(--color-secondary-text);
  font-size: var(--font-size-small);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.4s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
